module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-issue-8ff4d5f4.svg";